import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Whether Reconciliation (the Reconciliation tab on a Stock Unit and its lock) is part of the company's plan.
 * Tree and Forest have it; Seedling and Sapling do not (a company with the Inventory module always does).
 *
 * Filled once from the bootstrap call. Defaults to TRUE so nothing is hidden while the answer is still on its
 * way, or if it never comes — the server refuses the calls anyway (403 PLAN_FEATURE_DISABLED), the tab is only
 * hidden so people are not shown something their plan does not include.
 */
@Injectable({ providedIn: 'root' })
export class ReconciliationAccessService {
  private readonly enabledSubject = new BehaviorSubject<boolean>(true);
  readonly enabled$ = this.enabledSubject.asObservable();

  get enabled(): boolean {
    return this.enabledSubject.value;
  }

  setFromBootstrap(enabled: boolean): void {
    this.enabledSubject.next(enabled !== false);
  }
}
